<template>
	<el-container>
		<div class="colhead">
			<h2 class="header_h2">企业信息管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="企业名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>
		
		</el-header>
		<el-main>
			<div>
			<el-table border ref="multipleTable" tooltip-effect="dark"  :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="isvalid" label="启用" width="50px">
					<template slot-scope="scope">
						<label v-if='scope.row.isvalid=="0"'>禁用</label>
						<label v-if='scope.row.isvalid=="1"'>启用</label>
					</template>
				</el-table-column>
				<el-table-column prop="corp_name" label="企业名称" width="200px"></el-table-column>
				<el-table-column prop="corp_type" label="企业类型">
				<template slot-scope="scope">
					<label v-if='scope.row.corp_type=="0"'>体检中心</label>
					<label v-if='scope.row.corp_type=="1"'>医院</label>
				</template>
				</el-table-column>
				<el-table-column prop="corp_level" label="信誉度"></el-table-column>
				
				<el-table-column prop="emp_name" label="操作员"></el-table-column>
				<el-table-column prop="emp_date" label="操作时间" width="120px"></el-table-column>
				<el-table-column label="操作" width="100px" fixed="right">
					<template slot-scope="scope">
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
			</div>
		</el-main>
		<!-- 修改个人信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="EditInfo.isvalid" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="企业名称">
					<el-input  v-model="EditInfo.corp_name"></el-input>
				</el-form-item>
				<el-form-item label="企业类型">
				    <el-select v-model="EditInfo.corp_type" placeholder="请选择" style="width: 100%;">
				      <el-option v-for="item in emCorpType" :label="item.key" :value="item.value">{{ item.key }}</el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="信誉度">
					<el-input  v-model="EditInfo.corp_level"></el-input>
				</el-form-item>
				
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>
			
		</el-dialog>

		<!-- ----新增个人信息---- -->
		<el-dialog title="新增企业信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="chk" ></el-switch>
				</el-form-item>
				<el-form-item label="企业名称">
					<el-input  v-model="AddInfo.corp_name"></el-input>
				</el-form-item>
				<el-form-item label="企业类型">
				    <el-select v-model="AddInfo.corp_type" placeholder="请选择" style="width: 100%;">
				      <el-option v-for="item in emCorpType":label="item.key"  :value="item.value">{{ item.key }}</el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="信誉度">
					<el-input  v-model="AddInfo.corp_level"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-container>
</template>



<script>
	import enums from '../../commontools/enums.js'
	import corp from '../../apifunction/Corp.js'
	import comfun from '../../commontools/CommonFun.js'
	export default {
		data() {
			return {
				CorpData: [],
				emCorpType: enums.CorpType,
				chk:true,
				currentPage: 1,
				pagesize: 10,
				bao1look: false,
				bao1edit: false,
				bao1newadd: false,
				idx: null,
				//   通过姓名查询
				select_word: "",
				
				EditInfo: {
					corp_id: '',
					corp_name: '',
					corp_type: '',
					corp_level: 0,
					isvalid: '0',
					emp_id: '',
					emp_name: '',
					emp_date: ''
				},
				AddInfo: {
					corp_id: '',
					corp_name: '',
					corp_type: '',
					corp_level: 0,
					isvalid: '0',
					emp_id: '',
					emp_name: '',
					emp_date: ''
				}
			};
		},
		mounted() {
			this.getAllCorp();
		},
		methods: {
			//   得到所有的数据---------------
			getAllCorp() {
				corp.GetAllCorp()
				.then(res=>{
					let ent=JSON.parse(JSON.stringify(res.data) )
					if (ent.Flag=='success') {
						if(ent.Data!='null')
						this.CorpData=JSON.parse(ent.Data);
						
						
					} else
						this.$message.info(ent.Msg);
				})
				 // this.CorpData = enums.CorpData;
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 查看
			// 当点击查看时，让dialog显示,同时赋值数据
			handleClick(index, row) {
				this.bao1look = true;
				this.LookInfo = {
					corp_id: row.corp_id,
					corp_name: row.corp_name,
					corp_type: row.corp_type,
					corp_level: row.corp_level,
					isvalid: row.isvalid,
					emp_id: row.emp_id,
					emp_name: row.emp_name,
					emp_date: row.emp_date
				};
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;
				
				this.EditInfo = {
					corp_id: row.corp_id,
					corp_name: row.corp_name,
					corp_type: row.corp_type,
					corp_level: row.corp_level,
					isvalid: row.isvalid,
					emp_id: row.emp_id,
					emp_name: row.emp_name,
					emp_date: row.emp_date
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				this.EditInfo.emp_id = this.$myglobal.getUserInfo().id;
				this.EditInfo.emp_name = this.$myglobal.getUserInfo().username;
				this.EditInfo.emp_date = comfun.GetNowDateTime();
				corp.EditCorp(this.EditInfo)
				.then(res=>{
					
					let ent=JSON.parse(JSON.stringify(res.data) )
					if (ent.Flag=='success') {
						this.CorpData.splice(this.idx,1,this.EditInfo)
						this.bao1edit = false;
						this.$message.success("修改成功");
						
					} else
						this.$message.info(ent.Msg);
				})
				
			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.corp_name='';
				this.AddInfo.corp_type='0';
				this.AddInfo.corp_level=1;
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if(this.AddInfo.corp_name=='')
				{
					this.$message.success("企业名称不能为空！");
					return;
				}
				this.AddInfo.emp_id = this.$myglobal.getUserInfo().id;
				this.AddInfo.emp_name = this.$myglobal.getUserInfo().username;
				this.AddInfo.emp_date = comfun.GetNowDateTime();
				this.AddInfo.corp_id =comfun.NewGuid();
				// this.$refs.AddInfo.validate(valid => {
				// 	if (valid) {
				// 		// 删除尾部数据，并且在头部添加
				// 		this.data.unshift(this.AddInfo);
				// 		this.bao1newadd = false;
				// 		this.$message.success("新增成功");
				// 	}
				// });
				corp.AddCorp(this.AddInfo)
				.then(res=>{
					let ent=JSON.parse(JSON.stringify(res.data) )
					if (ent.Flag=='success') {
						this.data.unshift(this.AddInfo);
						this.bao1newadd = false;
						this.$message.success("新增成功");
						
					} else
						this.$message.info(ent.Msg);
				})
			},
					},
		computed: {
			data() {
				return this.CorpData.filter(item => {
					 if (this.select_word == '')
					 	return item;
					 else if (item.corp_name.indexOf(this.select_word) > -1) {
					 	return item;
					 }
				});
			}
		}
	};
</script>


<style >

</style>
